import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filesize',
    standalone: false
})
export class FilesizePipe implements PipeTransform {

  transform(value: number | string): string {
    const bytes = Number(value);
    if (isNaN(bytes) || bytes === 0) {
      return '0 B';
    }
    const units = ['B', 'kB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1000));
    return parseFloat((bytes / Math.pow(1000, i)).toFixed(2)) + ' ' + units[i];
  }

}
